export const getProjectId = (project) =>
  project?.projectId ?? project?.Id ?? project?.id ?? null;

export const isProjectArchived = (project) => {
  const raw =
    project?.isArchived ??
    project?.IsArchived ??
    project?.is_archived ??
    project?.archived;
  if (raw === undefined || raw === null) return false;
  return Boolean(raw);
};

export const getProjectName = (project) =>
  project?.projectName ??
  project?.ProjectName ??
  project?.Project_Name ??
  project?.name ??
  project?.title ??
  project?.Title ??
  "";

export const getProjectSourcesCount = (project) => {
  if (!project) return null;
  const explicit =
    project.sourcesCount ??
    project.sourceCount ??
    project.sources ??
    project.filesCount ??
    project.fileCount;
  if (explicit != null && explicit !== "") {
    const n = Number(explicit);
    return Number.isFinite(n) ? n : null;
  }
  const raw =
    project.knowledgeFiles ??
    project.files ??
    project.documents ??
    project.KnowledgeFiles;
  if (Array.isArray(raw)) return raw.length;
  return null;
};

const PROJECT_BALL_GRADIENTS = [
  "radial-gradient(circle at 32% 28%, #ffe8d4 0%, #ffb48a 42%,rgb(237, 185, 159) 100%)",
  "radial-gradient(circle at 32% 28%, #d9fbf0 0%, #8fe3d2 48%, #5fd4c8 100%)",
  "radial-gradient(circle at 32% 28%, #ffd8e4 0%, #ffb0c4 45%, #f498b0 100%)",
  "radial-gradient(circle at 32% 28%, #eef0ff 0%, #c5ceff 45%, #a8b5f5 100%)",
];

function projectBallIndex(project) {
  const id = getProjectId(project);
  const name = getProjectName(project);
  const key = `${id ?? ""}:${name ?? ""}`;
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return hash % PROJECT_BALL_GRADIENTS.length;
}

export function getProjectBallBackground(project) {
  return PROJECT_BALL_GRADIENTS[projectBallIndex(project)];
}
